import { memo, useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { PanelMenu } from "primereact/panelmenu"
import { LoaderProgressBar } from "../../Loaders"
import {
  buildPanelMenuModel,
  renderMaterialIconMenuItemTemplate,
} from "./helpers/menuBuilder"
import useMainMenu from "../../../hooks/useMainMenu"

// hooks
import useMenuItems from "./hooks/useMenuItems"

import baseStyles from "../../../styles/SidebarPanelMenuBase.module.css"

function StaffMenu() {
  const navigate = useNavigate()
  const location = useLocation()
  const { resolveMenuPath } = useMainMenu()
  // `useMenuItems` returns [loading, items] for the requested sidebar context.
  const [loading, items] = useMenuItems("staff")

  const staffMenuModel = useMemo(() => {
    // Shared helper handles route matching, active-class assignment, and parent expansion propagation.
    return buildPanelMenuModel({
      items,
      pathname: location.pathname,
      navigate,
      itemTemplate: renderMaterialIconMenuItemTemplate,
      activeClassName: baseStyles.menuLinkActiveItem,
      resolvePath: resolveMenuPath,
    })
  }, [items, location.pathname, navigate, resolveMenuPath])

  if (loading) return <LoaderProgressBar />

  if (!staffMenuModel.length) return null

  return (
    <div className={baseStyles.menuRoot}>
      <PanelMenu
        // Remount on pathname change so PrimeReact re-reads `expanded` flags from the model.
        key={`staff-menu-${location.pathname}`}
        model={staffMenuModel}
        multiple={false}
      />
    </div>
  )
}

// Export component wrapped in React.memo to prevent unnecessary renders
export default memo(StaffMenu)
